// extracted by mini-css-extract-plugin
export default {"pan":"signup_pan__qC6ej","btnsignup":"signup_btnsignup__KJ3NV","card":"signup_card__RsOsR"};